module.exports = __webpack_public_path__ + "media/assets/img/flags/lv-LV-a53591bd0c92775510397ab6c56d7cf6.png";